import { createFormControl, useFormState } from 'react-hook-form';
import { ApplicantsFormDataValues } from './schema';
import { useMemo } from 'react';
import { useApplicantsFormOnSubmitFactory } from './onSubmit';

const formControls: Record<
  string,
  ReturnType<typeof createFormControl<ApplicantsFormDataValues>>
> = {};

export const getApplicantsFormContext = (applicationID: string) => {
  if (!formControls[applicationID])
    formControls[applicationID] = createFormControl();

  return formControls[applicationID];
};

export const useApplicantsFormContext = (applicationID: string) => {
  const formContext = getApplicantsFormContext(applicationID);
  const submit = useApplicantsFormOnSubmitFactory({
    applicationID,
    formContext,
  });

  const formState = useFormState({ control: formContext.control });

  return useMemo(
    () => ({
      ...formContext,
      formState,
      handleSubmit: undefined,
      submit,
    }),
    [formContext, submit, formState],
  );
};
